import { notifyAlert, notifySuccess, notifyFailure } from 'app/Notifications/actions';
import { visitPage } from 'app/Router/actions';
import { changeDir } from 'app/Tree/actions';
import { getFolderThunk } from 'app/Tree/thunks';

import { PUBLISHED } from 'lib/versions';
import { getPageFailure, getPageRequest, getPageSuccess } from './actions';

/**
 * request a page
 * @param {object} params - function params
 * @param {string} params.id - UUID of page
 * @param {string} params.version - page version
 * @returns {Function} thunk
 */
export const getPage = ({ id, version }) => async (dispatch, _, { api }) => {
  try {
    dispatch(getPageRequest({ id, version }));
    const response = await api.page.getPage({ id, version });
    dispatch(getPageSuccess(id, response));
    dispatch(getFolderThunk(response?.ParentFolderId));
    dispatch(changeDir(response?.ParentFolderId));
  } catch (error) {
    dispatch(getPageFailure(error));
  }
};

/**
 * resync flash event landing page
 * @param {object} payload - flash event page details
 * @returns {undefined}
 */
export const resyncFlashEventLP = payload => async (dispatch, _, { api }) => {
  try {
    dispatch(notifyAlert(`Resyncing '${payload.pageName}'...`));
    const res = await api.workflow.createFlashEventPage(payload);

    const { landingPage } = res;
    if (!landingPage) {
      throw new Error('Response did not include `landingPage`');
    }

    dispatch(visitPage(landingPage, PUBLISHED));
    dispatch(notifySuccess(`Successfully resynced and saved '${payload.pageName}'!`));
  } catch (err) {
    dispatch(notifyFailure(err.toString()));
  }
};
